// @mui material components
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import colors from "assets/theme/base/colors";

import React, { useEffect, useState } from "react";
import MarketCard from "examples/Cards/MarketCard/MarketCard";
import { useWallet } from "WalletProvider";
import { useReadContract } from "wagmi";
import contractABI from "../../assets/contractABI.json";
import { getChainName } from "utilities/utilites";

function Dashboard() {
  const { selectedChain } = useWallet();
  const [marketData, setMarketData] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    data: markets,
    isLoading,
    isError,
  } = useReadContract({
    abi: contractABI,
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    functionName: "getAllMarketsByChain",
    args: [BigInt(selectedChain), BigInt(0), BigInt(5)],
  });
  
  // const sortedMarkets = markets
  // ? [...markets].sort((a, b) => {
  //     // First, sort by status (ascending: 0 → 1 → 2)
  //     if (a.status !== b.status) {
  //       return a.status - b.status;
  //     }
  //     // Then, sort by createdAt (descending: latest first)
  //     return Number(b.createdAt) - Number(a.createdAt);
  //   })
  // : [];

  useEffect(() => {
    if (!markets || markets.length === 0) return;

    setLoading(true);

    Promise.all(
      markets.map(async (market) => {
        try {
          const [motherRes, childRes] = await Promise.all([
            fetch(
              `https://api.dexscreener.com/latest/dex/pairs/${getChainName(market.motherChain)}/${
                market.motherPairAddress
              }`
            ).then((res) => res.json()),
            fetch(
              `https://api.dexscreener.com/latest/dex/pairs/${getChainName(market.childChain)}/${
                market.childPairAddress
              }`
            ).then((res) => res.json()),
          ]);
          return {
            ...market,
            motherData: motherRes,
            childData: childRes,
          };
        } catch (error) {
          console.error("Error fetching market data:", error);
          return null;
        }
      })
    )
      .then((results) => {
        const validMarkets = results.filter((market) => market !== null);

        const sortedMarkets = validMarkets.sort((a, b) => {
          if (a.status !== b.status) return a.status - b.status;
          return Number(b.createdAt) - Number(a.createdAt);
        });

        
        setMarketData(sortedMarkets);
      })
      .finally(() => setLoading(false));
  }, [markets]);

  // useEffect(() => {
  //   if (!markets || markets.length === 0) return;

  //   setLoading(true);

  //   Promise.all(
  //     markets.map((market) =>
  //       fetch(`https://api.dexscreener.com/latest/dex/pairs/${getChainName(market.motherChain)}/${market.motherPairAddress}`)
  //         .then((res) => res.json())
  //         .then((data) => ({ ...market, data })) // Merge contract data with API response
  //         .catch(() => null) // Handle errors gracefully
  //     )
  //   )
  //     .then((results) => {
  //       const validMarkets = results.filter((market) => market !== null);
  //       const filterd = validMarkets ? [...validMarkets].sort((a, b) => {
  //         // First, sort by status (ascending: 0 → 1 → 2)
  //         if (a.status !== b.status) {
  //           return a.status - b.status;
  //         }
  //         // Then, sort by createdAt (descending: latest first)
  //         return Number(b.createdAt) - Number(a.createdAt);
  //       })
  //     : [];
  //     console.log("filterexc")
  //     console.log(filterd)
  //       setMarketData(filterd);
  //     })
  //     // .finally(() => setLoading(false));
  // }, [markets]); // ✅ Depend on `markets` from contract

  setTimeout(() => {
    setLoading(false);
  }, 3000);
  if (isLoading) {
    return (
      //  <CircularProgress color="primary" size={50} />
      <VuiBox
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        bgcolor="rgba(0,0,0,0.3)" // Optional dark overlay
        borderRadius="8px"
      >
        <CircularProgress color="primary" size={50} />
      </VuiBox>
    );
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
        <Grid container spacing={3}>
  {marketData.length > 0 ? (
    marketData.map((market, index) => {
      // Condition to check if both motherData.pair and childData.pair are null
      const shouldHideMarketCard =
        market.motherData?.pair === null && market.childData?.pair === null;

      // If both pairs are null, don't render anything
      if (shouldHideMarketCard) return null;

      return (
        <React.Fragment key={index}>
          {!market.motherData && !market.childData && (
            <VuiBox
              sx={{
                height: "100vh",
                display: "flex",
                alignItems: "top",
                justifyContent: "top",
              }}
            />
          )}

          <Grid item xs={12} md={6} xl={4}>
            <MarketCard
              marketId={market.id}
              marketTitle={market.name}
              marketCreationDate={market.createdAt}
              motherToken={market.motherToken}
              motherPairAddress={market.motherPairAddress}
              motherChain={market.motherChain}
              motherTVL={market.motherTVL}
              childToken={market.childToken}
              childPairAddress={market.childPairAddress}
              childChain={market.childChain}
              childTVL={market.childTVL}
              action={{
                type: "internal",
                route: `/marketdata/${market.id}`,
                color: "warning",
                label: "View market",
              }}
              status={market.status}
              creator={market?.creator}
              motherTokenDecimal={market?.motherTokenDecimal}
              childTokenDecimal={market?.childTokenDecimal}
              mergedAt={market?.mergedAt}
            />
          </Grid>
        </React.Fragment>
      );
    })
  ) : (
    <VuiBox
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "top",
        justifyContent: "top",
      }}
    >
      <VuiTypography
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
          color: "#ffffff",
        }}
      >
        Fetching Markets...
      </VuiTypography>
    </VuiBox>
  )}
</Grid>

        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
